const SIGN_ON_URL_HEADER_NAME = 'Signonurl';

export function handleSignOnRedirect(response: Response) {
	if (response.status === 401) {
		const signOnUrl = response.headers.get(SIGN_ON_URL_HEADER_NAME);
		if (signOnUrl) {
			window.location.assign(signOnUrl);
			return true;
		}
	}
	return false;
}
